import React, { ReactChild, useState } from 'react';

interface Props {
  children: ReactChild;
}

export function Page({ children }: Props) {
  return <main className="flex-1 bg-black h-screen relative overflow-y-auto focus:outline-none">{children}</main>;
}
